export default __webpack_public_path__ + "static/media/up.3e3930a2.svg";